export const translations = {
  sv: {
    toggleLinkTitleText: `Välj kundnummer`,
  },
  en: {
    toggleLinkTitleText: `Choose customernumber`,
  },
  da: {
    toggleLinkTitleText: `Vælg kundenummer`,
  },
  no: {
    toggleLinkTitleText: `Velg kundenummer`,
  },
  fi: {
    toggleLinkTitleText: `Valitse asiakasnumero`,
  },
  de: {
    toggleLinkTitleText: `Kundennummer auswählen`,
  },
};
